"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleNotAuthenticatedError = exports.isNotAuthenticatedError = exports.error = exports.log = void 0;
/** LOGGING **/
var log = function (message) { return console.log("> ".concat(message)); };
exports.log = log;
var error = function (message) { return console.error("> ERROR: ".concat(message)); };
exports.error = error;
var isNotAuthenticatedError = function (error) {
    return (typeof error === 'string' && error.includes('not authenticated')) ||
        (error instanceof Error && error.message.includes('not authenticated'));
};
exports.isNotAuthenticatedError = isNotAuthenticatedError;
var handleNotAuthenticatedError = function (err) {
    if ((0, exports.isNotAuthenticatedError)(err)) {
        window.location.href = '/login';
    }
};
exports.handleNotAuthenticatedError = handleNotAuthenticatedError;
